module.exports = __webpack_public_path__ + "staticcomp/img/share.4336d57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/2/share.jpg
// module id = L41w
// module chunks = 39